import { Reveal } from "./Reveal";
import { EMAIL, PHONE, PHONE_LINK, MAILTO } from "@/lib/site";
import { scrollToId } from "@/lib/scroll";

const FOOTER_LINKS = [
  { label: "For EPC/Integrators", id: "#what-we-do", audience: "ci" },
  { label: "For Utilities", id: "#what-we-do", audience: "utilities" },
  { label: "Technology", id: "#technology" },
  { label: "Team", id: "#team" },
];

export const Contact = ({ onSelectAudience, onOpenTechnology }) => (
  <section
    id="contact"
    data-testid="contact-closing-section"
    className="pt-20 sm:pt-28 lg:pt-36 pb-10"
  >
    <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
      <Reveal>
        <p className="font-mono text-xs uppercase tracking-[0.22em] text-[#2C4A3A] font-semibold">
          04 / Contact
        </p>
        <h2
          data-testid="contact-closing-headline"
          className="mt-8 text-3xl sm:text-4xl lg:text-6xl font-medium tracking-tight leading-[1.08] text-[#121413] max-w-3xl"
        >
          Every asset, perfectly utilised.
        </h2>
        <p className="mt-6 max-w-xl text-base sm:text-lg leading-relaxed text-[#4A4D4A]">
          We work with anyone who wants to optimise their renewable energy
          system. If you are a distribution utility, renewable developer, an
          EPC/BESS integrator, or anyone else looking to build a renewable
          energy solution, let us get in touch! Tell us about your project or
          network. We will simulate your systems &amp; get back with a plan.
        </p>
        <div className="mt-10 flex flex-wrap items-center gap-x-8 gap-y-5">
          <span
            data-testid="contact-cta-visual"
            className="inline-flex items-center gap-3 bg-[#2C4A3A] text-[#FAF9F6] px-8 py-4 text-sm font-medium select-none"
          >
            Get in touch
            <span>→</span>
          </span>
          <div className="flex flex-col gap-1.5">
            <a
              data-testid="contact-email-link"
              href={MAILTO}
              className="font-mono text-sm text-[#121413] border-b border-[#C5C1B6] pb-0.5 self-start hover:text-[#2C4A3A] hover:border-[#2C4A3A] transition-colors duration-300"
            >
              {EMAIL}
            </a>
            <a
              data-testid="contact-phone-link"
              href={PHONE_LINK}
              className="font-mono text-sm text-[#121413] border-b border-[#C5C1B6] pb-0.5 self-start hover:text-[#2C4A3A] hover:border-[#2C4A3A] transition-colors duration-300"
            >
              {PHONE}
            </a>
          </div>
        </div>
      </Reveal>

      <footer
        data-testid="main-footer"
        className="mt-24 sm:mt-32 border-t border-[#E2DFD7] pt-8 flex flex-col sm:flex-row sm:items-center justify-between gap-6"
      >
        <div className="flex items-center">
          <img src="/assets/lockup-side-mono-ink.png" alt="Shikra Energy" className="h-11 w-auto" />
        </div>
        <nav className="flex items-center gap-6">
          {FOOTER_LINKS.map((l) => (
            <button
              key={l.id + l.label}
              data-testid={`footer-link-${l.label.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "")}`}
              onClick={() => {
                if (l.audience && onSelectAudience) onSelectAudience(l.audience);
                if (l.id === "#technology" && onOpenTechnology) onOpenTechnology();
                scrollToId(l.id);
              }}
              className="text-sm text-[#7A7E7A] hover:text-[#121413] transition-colors duration-300"
            >
              {l.label}
            </button>
          ))}
          <a
            data-testid="footer-link-linkedin"
            href="https://www.linkedin.com/company/shikra-energy-iitm/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-[#7A7E7A] hover:text-[#121413] transition-colors duration-300"
          >
            LinkedIn
          </a>
        </nav>
        <p className="text-xs text-[#7A7E7A]">© 2026 Shikra Energy. All rights reserved.</p>
      </footer>
    </div>
  </section>
);
